<template>
  <div class="open_task">
    <div class="title">开张任务</div>
    <div class="task_item">
      <div style="flex: 1">
        <div class="tit"><span class="no">1.</span> 基本资料完善</div>
        <div class="hint">店铺负责人、客服电话、店铺简介等资料</div>
      </div>
      <div v-if="!infoStatus" class="btn" @click="goShopInfo">去完善</div>
      <div v-else class="btn status">已完成</div>
    </div>
    <!-- <div class="task_item">
      <div style="flex: 1">
        <div class="tit"><span class="no">2.</span> 店铺名称审核</div>
        <div class="hint">开店时填写的店铺名称进行审核</div>
      </div>
      <div v-if="data.check_info==0" class="btn status" style="background: #e79e9e">审核中</div>
      <div v-if="data.check_info==1" class="btn status">审核通过</div>
      <div v-if="data.check_info==2" class="btn status" style="background: #e8244a" @click="goShopName">审核驳回</div>
    </div> -->
    <div class="task_item">
      <div style="flex: 1">
        <div class="tit"><span class="no">2.</span> 店铺主体认证</div>
        <div class="hint">
          需要对店铺主体进行认证，如店铺类型、企业法人经营等资质
        </div>
      </div>
      <div v-if="shopStatus == -1" class="btn" @click="goShopAuth">去完善</div>
      <div
        v-if="shopStatus == 2"
        class="btn status"
        style="background: #e8244a"
      >
        审核驳回
      </div>
      <div
        v-if="shopStatus == 0"
        class="btn status"
        style="background: #e79e9e"
      >
        审核中
      </div>
      <div v-if="shopStatus == 1" class="btn status">审核通过</div>
    </div>

    <Modal title="基本资料完善" width="700" v-model="modalInfo">
      <Form
        ref="form"
        class="setting-form-box"
        style="padding-left: 30px"
        :model="data"
        :rules="rule"
        :label-width="120"
        label-colon
      >
        <FormItem label="店铺负责人" prop="contacts" style="width: 80%">
          <Input v-model="data.contacts"></Input>
        </FormItem>
        <FormItem label="负责人手机号" prop="contacts_tel" style="width: 80%">
          <Input v-model="data.contacts_tel" :maxlength="11"></Input>
        </FormItem>
        <FormItem label="所在地区" required style="width: 80%">
          <al-selector
            :gutter="0"
            data-type="name"
            searchable
            v-model="data.location"
            level="2"
          />
        </FormItem>
        <FormItem label="邮箱" prop="email" style="width: 80%">
          <Input v-model="data.email"></Input>
        </FormItem>
        <FormItem label="客服电话" prop="service_tel" style="width: 80%">
          <Input v-model="data.service_tel"></Input>
          <div class="describe">
            买家可通过客服电话与你联系，将展示在订单详情中
          </div>
        </FormItem>
        <FormItem label="店铺简介" prop="introduce" style="width: 80%">
          <Input
            type="textarea"
            v-model="data.introduce"
            :maxlength="100"
            show-word-limit
            :autosize="{ minRows: 4 }"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="save">确认</Button>
        <Button @click="modalInfo = false" style="margin-right: 10px"
          >取消</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      modalInfo: false,
      data: {
        id: 0,
        company_name: "",
        name: "",
        province: "",
        city: "",
        area: "",
        location: [], //
        address: "",
        contacts: "",
        contacts_tel: "",
        account_bank: "",
        bank_no: "",
        licence: "",
        id_card: "",
        email: "",
        logo: "",
        introduce: "",
        account_name: "",
        Invoice_title: "",
        taxpayer_code: "",
        tel: "",
        user_id: 0,
        status: "",
        star: 0,
        is_recommend: 0,
        remote_city: "",
        remote_city_arr: [],
        reason: "",
      },
      rule: {
        contacts: [
          {
            required: true,
            type: "string",
            message: "请填写店铺负责人",
            trigger: "blur",
          },
        ],
        contacts_tel: [
          {
            required: true,
            type: "string",
            message: "请填写正确的负责人手机号",
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (!/^[1][3,4,5,7,8,9][0-9]{9}$/.test(value)) {
                callback(new Error("请填写正确的负责人手机号"));
                return false;
              }
              callback();
            },
          },
        ],
        // location: [
        //   {
        //     required: true,
        //     message: "请选择所在地区",
        //     validator: (rule, value, callback) => {
        //       if (!data.location) {
        //         callback(new Error("请选择所在地区"));
        //         return false;
        //       }
        //       callback();
        //     },
        //   },
        // ],
        email: [
          {
            required: true,
            type: "email",
            message: "请填写正确的邮箱",
            trigger: "blur",
          },
        ],
        service_tel: [
          {
            required: true,
            type: "string",
            message: "请填写客服电话",
            trigger: "blur",
          },
        ],
        introduce: [
          {
            required: true,
            type: "string",
            message: "请填写店铺简介",
            trigger: "blur",
          },
        ],
      },
      infoStatus: false, //基本资料完善状态
      shopStatus: -1, //店铺主体审核状态
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    ...mapActions(["GetShopInfo", "PutShopInfo"]),
    getData() {
      this.GetShopInfo().then((res) => {
        this.data = res.data;
        this.data.location = [
          this.data.province,
          this.data.city,
          this.data.area,
        ];

        let data = this.data;
        if (
          data.contacts &&
          data.contacts_tel &&
          data.location &&
          data.email &&
          data.service_tel &&
          data.introduce
        ) {
          this.infoStatus = true;
        }
        this.shopStatus = this.shop_agent.check_status;

      });
    },
    save() {
      let data = this.data;
      data.province = this.data.location[0];
      data.city = this.data.location[1];
      data.area = this.data.location[2];
      data.logo = undefined;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.PutShopInfo(this.data).then((res) => {
            this.modalInfo = false;
            this.isEdite = false;
            this.$Message[res.status ? "success" : "error"](res.msg);
            if (!res.status) return false;
            this.getData();
          });
        }
      });
    },
    goShopInfo() {
      this.modalInfo = true;
    },
    goShopAuth() {
      this.$router.push({ name: "shopAuth" });
    },
    goShopName() {
      this.$router.push({ name: "setting" });
    },
  },
  computed: mapGetters({
    shop_agent: "shop_agent",
  }),
};
</script>
<style lang="less">
.open_task {
  .title {
    font-size: 26px;
    font-weight: bold;
    padding: 15px 0;
    color: black;
    border-bottom: 1px solid #eeeeee;
  }
  .task_item {
    display: flex;
    align-items: center;
    padding: 30px 0;
    border-bottom: 1px solid #eeeeee;
    .tit {
      color: black;
      font-size: 20px;
      .no {
        font-family: lucidasans;
        font-size: 24px;
        font-style: italic;
        // font-weight: bold;
      }
    }
    .hint {
      color: #999999;
      font-size: 16px;
      margin-top: 6px;
      margin-left: 25px;
    }
    .btn {
      color: white;
      font-size: 14px;
      background: #e8244a;
      height: 40px;
      line-height: 40px;
      text-align: center;
      width: 120px;
      border-radius: 20px;
      cursor: pointer;
      margin-left: 6px;
    }
    .status {
      background: #00b050;
    }
  }
}
.describe {
  color: #999999;
  font-size: 10px;
  height: 20px;
}
</style>
